import React from 'react';
import { generateBem } from '../../../utils/generateBem';

import './Metrics.scss';

const generalMetrics = [
  {
    value: '5K+',
    labelOne: 'Funds & Companies',
    labelTwo: 'Created / Managed',
  },
  {
    value: '$2B+',
    labelOne: 'Capital & Assets',
    labelTwo: 'Under Management',
  },
  {
    value: '50K+',
    labelOne: 'Contracts',
    labelTwo: 'Automated / Mapped',
  },
];

const fundMetrics = [
  {
    value: '5K+',
    labelOne: 'Funds & SPVs',
    labelTwo: 'Created / Managed',
  },
  {
    value: '$2B+',
    labelOne: 'Capital & Assets',
    labelTwo: 'Under Management',
  },
  {
    value: '50K+',
    labelOne: 'Contracts',
    labelTwo: 'Automated / Mapped',
  },
];

const bem = generateBem('metrics');

const Metric = ({ isLast, style, value, labelOne, labelTwo }) => (
  <div className={bem(['card', isLast && 'card--last'])}>
    <h3 className={bem('value')}>{value}</h3>
    <h4 className={bem('label')}>
      <b>{labelOne}</b>
      <span>{labelTwo}</span>
    </h4>
  </div>
);

export const MetricsList = ({ metricType }) => {
  const metrics = metricType === 'general' ? generalMetrics : fundMetrics;

  return (
    <section className={bem('wrapper')}>
      <div className={bem('list')}>
        {metrics.map((item, index) => (
          <Metric
            key={`metric-${index}`}
            {...item}
            isLast={index + 1 === metrics.length}
          />
        ))}
      </div>
      {/* <h2 className={bem('header')}>
        <span>Trusted By</span>
        <b>10k+</b>
        <span>Clients</span>
      </h2> */}
    </section>
  );
};
